import { useCallback, useState } from "react";
import Button, { EButtonColor, EButtonVariant } from "components/elements/Button";
import Typography from "components/elements/Typography";
import I18n from "components/materials/I18n";
import { VoteWithResults } from "hooks/useVote";
import VoteOption from "./VoteOption";
import VoteTag from "./VoteTag";
import classes from "./classes.module.scss";
import ManageCardMenu from "components/pages/ProfessionalSpace/components/ManageCardMenu";

type IProps = {
	voteWithResults: VoteWithResults;
	onDeleteClick: () => void;
	onEditClick: () => void;
};

function getTruncatedContent(content: string, seeMore: boolean, maxLength: number = 115): string {
	return content.length > maxLength && !seeMore ? `${content.slice(0, maxLength)}...` : content;
}

export default function VoteCard(props: IProps) {
	const { question } = props.voteWithResults;
	const { seeMore, toggleSeeMore } = useSeeMore();

	return (
		<div className={classes["root"]}>
			<div className={classes["header"]}>
				{question.endsAt && <VoteTag endDate={question.endsAt} />}

				<ManageCardMenu onDeleteClick={props.onDeleteClick} onEditClick={props.onEditClick} className={classes["menu"]} />
			</div>

			<div className={classes["content-container"]}>
				<div className={classes["description-container"]}>
					<Typography type="p" size="large" weight="medium" className={classes["content"]}>
						{getTruncatedContent(question.content, seeMore)}
					</Typography>

					{question.content.length > 115 && (
						<Button variant={EButtonVariant.TEXT} color={EButtonColor.PRIMARY} onClick={toggleSeeMore}>
							{!seeMore && I18n.asset.pages.professional_space.tabs.votes.see_more}
							{seeMore && I18n.asset.pages.professional_space.tabs.votes.see_less}
						</Button>
					)}
				</div>

				<div className={classes["vote-options-container"]}>
					{question.choices.map((choice) => (
						<VoteOption key={choice.id} choice={choice} voteWithResults={props.voteWithResults} showResults />
					))}
				</div>
			</div>
		</div>
	);
}

const useSeeMore = () => {
	const [seeMore, setSeeMore] = useState(false);

	const toggleSeeMore = useCallback(() => setSeeMore((prev) => !prev), []);

	return { seeMore, toggleSeeMore };
};
